// Similar to Bootstrap's scrollspy plugin.
// Takes a element with overflow:scroll content - finds all elements within
// with data attribute "scrollspy-target" and emits a "updateTarget" event
// whenever a one of these elements scrolls into view + provides a
// "scrollTo" method to scroll to a provided target element.
import jQuery from 'jquery';
import _ from 'lodash';

const UI = Mobi2Go.UI || {};
let instance = 0;

UI.ScrollSpy = function($content) {
    this.$content = $content;
    this.targets = [];
    this.current_target = null;

    // Add bind and trigger methods
    Mobi2Go.app.mixinEvents(`UIScrollSpy#${instance++}`, this);

    findContentTargets.call(this);
    addContentFiller.call(this);
    updateTarget.call(this);
    this.$content.bind('scroll', _.bind(updateTarget, this));
};

UI.ScrollSpy.prototype.scrollTo = function(target, callback) {
    let offset;
    let i;

    for (i in this.targets)
        if (this.targets.hasOwnProperty(i) && this.targets[i].id == target) {
            offset = this.targets[i].offset + 1;
        }
    if (offset === undefined) return;

    this.$content.animate({ scrollTop: offset }, 100, callback);
};

function findContentTargets() {
    const that = this;
    this.$content[0].scrollTop = 0; // Reset scroll for firefox
    this.$content.find('[data-scrollspy-target]').each(function() {
        const $this = jQuery(this);
        that.targets.push({
            id: $this.data('scrollspy-target'),
            offset: $this.position().top,
        });
    });

    this.targets.push({
        id: 'end',
        offset: this.$content[0].scrollHeight,
    });

    this.targets.sort(function(a, b) {
        return a.offset - b.offset;
    });
}

function updateTarget() {
    const scroll_top = this.$content[0].scrollTop;
    let i;
    let target;
    let prev = this.targets[0];
    for (i in this.targets)
        if (this.targets.hasOwnProperty(i)) {
            target = this.targets[i];
            if (
                scroll_top >= prev.offset &&
                scroll_top < target.offset &&
                this.current_target !== prev.id
            ) {
                this.trigger('updateTarget', (this.current_target = prev.id));
                return;
            }
            prev = target;
        }
}

function addContentFiller() {
    // Add filler to content if necessary to ensure last target in the
    // content can be scrolled into view
    const filler_height =
        this.$content.height() -
        (this.$content[0].scrollHeight -
            this.targets[this.targets.length - 2].offset) +
        1;

    if (filler_height > 0) {
        this.$content.append(
            `${'<div class="m2g-scrollspy-content-filler"' +
                ' style="height:'}${filler_height}px"><div>`
        );
    }
}
